<template>
    <div class="uw-files-box">
        <div class="uw-files-header">
            <div class="d-flex align-items-center gap-2">
                <span class="meta-header-icon meta-header-icon--blue">
                    <i class="bi bi-folder-symlink-fill"></i>
                </span>
                <div>
                    <h6 class="mb-0 fw-bold meta-header-title">Fayllar və sənədlər</h6>
                    <small class="text-muted" style="font-size: 0.76rem;">Əlavə edilmiş fayl və təsdiqedici sənədlər</small>
                </div>
            </div>
            <span class="meta-chip meta-chip--blue">{{ tableData ? tableData.length : 0 }} fayl</span>
        </div>

        <div class="uw-files-body">
            <div class="table-responsive">
                <el-table border class="el-table-css" :data="tableData" style="width: 100%;">
                    <el-table-column width="55" align="center">
                        <template #default="scope">
                            <button
                                type="button"
                                class="btn-download-icon"
                                title="Yüklə"
                                @click="download(scope.row.title)"
                            >
                                <i class="bi bi-download"></i>
                            </button>
                        </template>
                    </el-table-column>
                    <el-table-column label="Tarix" prop="createdDateStr" width="130" align="center">
                        <template #default="scope">
                            <span class="font-monospace text-xs" style="font-size: 0.8rem;">{{ scope.row.createdDateStr }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Faylın adı" min-width="250">
                        <template #default="scope">
                            <div class="d-flex align-items-center gap-2 py-1">
                                <img
                                    style="width: 24px; height: 24px; object-fit: contain;"
                                    :src="scope.row.ext === '.xlsx' ? require('@/assets/img/icons/microsoft-files/.xlsx.png') :
                                        scope.row.ext === '.docx' ? require('@/assets/img/icons/microsoft-files/.docx.png') :
                                            scope.row.ext === '.pdf' ? require('@/assets/img/icons/microsoft-files/.pdf.png') : require('@/assets/img/icons/microsoft-files/photo.png')"
                                    alt="file-icon"
                                >
                                <a
                                    @click="download(scope.row.title)"
                                    class="file-title-link"
                                >
                                    {{ scope.row.title }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UnderwritingFiles",
    data() {
        return {
            tableData: [
                {
                    createdDateStr: "21.08.2025",
                    title: "Hesabat_2025.xlsx",
                    ext: ".xlsx",
                    commandUserId: 1
                },
                {
                    createdDateStr: "19.08.2025",
                    title: "Müqavilə.docx",
                    ext: ".docx",
                    commandUserId: 2
                },
                {
                    createdDateStr: "15.08.2025",
                    title: "Şərtlər.pdf",
                    ext: ".pdf",
                    commandUserId: 1
                },
                {
                    createdDateStr: "10.08.2025",
                    title: "Foto.png",
                    ext: ".png",
                    commandUserId: 3
                }
            ]
        }
    },
    methods: {
        download(title) {
            console.log("Download file:", title);
        }
    }
}
</script>

<style scoped lang="scss">
.uw-files-box {
    background: var(--app-surface, #ffffff);
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 8px);
    overflow: hidden;
}

.uw-files-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 12px 16px;
    background: var(--app-surface-soft, #f8fafc);
    border-bottom: 1px solid var(--app-border, #e2e8f0);
}

.meta-header-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.88rem;
    flex-shrink: 0;

    &--blue { background: rgba(11, 79, 156, 0.12); color: var(--bs-info, #0b4f9c); }
}

.meta-header-title {
    font-size: 0.88rem;
    color: var(--app-heading, #1e293b);
}

.meta-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 700;

    &--blue { background: rgba(11, 79, 156, 0.1); color: var(--bs-info, #0b4f9c); }
}

.uw-files-body {
    padding: 12px 16px;
}

.btn-download-icon {
    background: none;
    border: none;
    color: var(--bs-info, #0b4f9c);
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    font-size: 0.95rem;
    transition: all 0.15s ease;

    &:hover {
        background: rgba(11, 79, 156, 0.1);
        transform: translateY(-1px);
    }
}

.file-title-link {
    color: var(--bs-info, #0b4f9c);
    font-weight: 550;
    font-size: 0.83rem;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

[data-theme="dark"] {
    .uw-files-box { background: #182029; border-color: #283544; }
    .uw-files-header { background: #141b22; border-color: #283544; }
    .meta-header-title { color: #f1f5f9; }
    .file-title-link { color: #93c5fd; }
    .btn-download-icon { color: #93c5fd; }
}
</style>